<template>
  <div >
    <van-popup style="height: 100vh;overflow-x: hidden" v-model="isShow" position="bottom" >
    <div style="position: relative">
    <div class="search">
    <van-search
      v-model="form.search"
      show-action
      shape="round"
      ref="searchInput"
      background="transparent"
      style="position: relative; z-index: 10"
      @focus="rollShow = false"
      @blur="rollShow = true"
      @search="onSearch(form.search)"
    >
        <div slot="left-icon">
         <img :src="icon.searchGray" style="width: 13px;margin-left: 13px;transform: translateY(1px)">
        </div>
      <div style="line-height: 20px;color: #2B2D2F; width: 30px;transform: translateX(5px)" class="centerBox"  slot="action">
        <div style="font-size: 14px;" @click="isShow = false">取消</div>
      </div>
    </van-search>
      <div v-if="!form.search && rollShow" style="position: absolute;font-size: 12px;color: #999999;top: 18px;left: 75px;z-index: 10;overflow: hidden;width: 65vw;height: 18px;pointer-events: none;">
        <van-swipe
          vertical
          @change="rollChange"
          :touchable="false"
          :autoplay="goodsCheckHotConfig.rollList[currentRowIndex] ? goodsCheckHotConfig.rollList[currentRowIndex].stopTime * 1000 : 3000"
          :show-indicators="false"
        >
          <van-swipe-item v-for="(item, index) in goodsCheckHotConfig.rollList" :key="index">
            <span style="font-family: lthj;">{{item.wordName}}</span>
          </van-swipe-item>
        </van-swipe>
      </div>
    </div>
    <div :style="`height: calc(100vh - 82px);width: 100vw;overflow-y: auto;${loading ? 'position: absolute;left: 100vw;top: 0' : ''}`">
      <div style="margin-top: 1.13vw;width: 92vw;padding: 0 4vw">
        <div style="font-size: 3.73vw;color: #2B2D2F;font-weight: bold">
          历史记录
          <div style="float: right" @click="clearHistory">
            <img src="../../assets/img/icon/delete.png" style="width: 3.73vw;margin-top: .6vw">
          </div>
        </div>
      </div>
      <div ref="historyContent" :style="`position: relative;margin-top: 2.53vw;width: 94.67vw;margin-right: 1.33vw;padding: 0 0 0 4vw;display: flex;flex-wrap: wrap;${moreHistoryUp ? '' : 'height: 20vw;overflow: hidden'}`">
        <div v-for="(item, index) in goodsCheckHotConfig.historyList" :key="index">
          <div class="searchHistoryItem" @click="onSearch(item)" v-if="!moreHistoryUp ? index < maxHistory : index < 20">
            <div>{{item}}</div>
          </div>
        </div>
        <div v-if="goodsCheckHotConfig.historyList.length && moreHistoryShow" :style="`display: inline-flex;margin-top: 2.67vw`" @click="moreHistoryUp = !moreHistoryUp">
<!--          <img src="../../assets/img/searchSpreadIcon.png" :style="`width: 8vw;height: 8vw;${moreHistoryUp ? 'transform: rotate(180deg)' : ''}`">-->
        </div>
      </div>
      <div style="width: 92vw;padding: 5.33vw 4vw 0;margin-top: 4vw;position: relative">
        <div style="position: absolute;top: 0;left: 0">
<!--          <img src="../../assets/img/searchHotBg.png" style="width: 100vw;">-->
        </div>
        <div style="display: flex;position: relative">
<!--          <img src="../../assets/img/searchFireIcon.png" style="width: 4.4vw;margin-right: 1.2vw;position: relative;height: 5.07vw">-->
<!--          <img src="../../assets/img/searchTitleIcon.png" style="width: 19.6vw;position: relative;height: 5.07vw">-->
        </div>
        <div style="padding-left: 2.53vw;position: relative;padding-top: .7vw">
          <div v-for="(item, index) in goodsCheckHotConfig.hotList" @click="onSearch(item.wordName)" :key="index" class="searchHotItem">
            <div class="searchHotIcon">
              <img v-if="index === 0" src="../../assets/img/icon/searchHotNum1.png" style="width: 4.53vw">
              <img v-else-if="index === 1" src="../../assets/img/icon/searchHotNum2.png" style="width: 4.53vw">
              <img v-else-if="index === 2" src="../../assets/img/icon/searchHotNum3.png" style="width: 4.53vw">
<!--              <div style="transform: translateY(-.3vw)" v-else>-->
<!--                {{index + 1}}-->
<!--              </div>-->
            </div>
            <div style="font-size: 3.47vw;color: #202020;">
              <div style="transform: translateY(.1vw)">{{item.wordName}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </div>
    </van-popup>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
// import navbarIconLeft from '../../assets/img/searchInputIcon.png'
import searchGray from '../../assets/img/icon/searchGray.png'

export default {
  props: {
    isShowNum: Number
  },
  data () {
    return {
      icon: {
        // navbarIconLeft
        searchGray
      },
      isShow: false,
      userData: {},
      goodsCheckHotConfig: {
        historyList: [],
        hotList: [],
        rollList: []
      },
      form: {
        search: ''
      },
      rollShow: true,
      moreHistoryUp: false,
      moreHistoryShow: false,
      defaultSearch: '',
      maxHistory: 20,
      loading: false,
      currentRowIndex: 0
    }
  },
  watch: {
    isShowNum () {
      this.isShow = true
      this.selectGoodsCheckHotConfig()
    }
  },
  created () {
  },
  activated () {
    // this.selectGoodsCheckHotConfig()
  },
  mounted () {
    // setTimeout(() => {
    //   this.$refs.searchInput.children[1].children[0].children[1].children[0].children[0].focus()
    // }, 300)
  },
  destroyed () {
  },
  methods: {
    ...mapActions([
      'set_row',
      'set_keepAliveList'
    ]),
    onClickLeft () {
      this.$router.go(-1)
    },
    onSearch (value) {
      this.$emit('onSearch', value)
    },
    rollChange (index) {
      this.currentRowIndex = index
      this.defaultSearch = this.goodsCheckHotConfig.rollList[index].wordName || ''
    },
    autoHistory () {
      if (this.$refs.historyContent.scrollHeight > this.$refs.historyContent.clientHeight && this.maxHistory > 1) {
        setTimeout(() => {
          this.maxHistory--
          this.autoHistory()
        }, 1)
      } else {
        this.$toast.clear()
        this.loading = false
      }
    },
    selectGoodsCheckHotConfig () {
      this.$toast.loading({
        duration: 0
      })
      this.$request.shop.selectGoodsCheckHotConfig()
        .then((response) => {
          this.goodsCheckHotConfig = {
            historyList: response.data.historyList || [],
            hotList: response.data.hotList || [],
            rollList: response.data.rollList || []
          }
          if (this.goodsCheckHotConfig.rollList.length) {
            this.defaultSearch = this.goodsCheckHotConfig.rollList[0].wordName || ''
          }
          setTimeout(() => {
            if (this.goodsCheckHotConfig.historyList.length) {
              this.moreHistoryShow = this.$refs.historyContent.scrollHeight > this.$refs.historyContent.clientHeight
              this.goodsCheckHotConfig.historyList.reverse()
              this.autoHistory()
            } else {
              this.$toast.clear()
              this.loading = false
            }
          }, 300)
        })
        .catch((error) => {
          console.log(error)
        })
    },
    clearHistory () {
      this.$dialog.confirm({
        message: '确认删除全部历史记录？'
      }).then(() => {
        this.cleanHistoryGoodsName()
      })
    },
    cleanHistoryGoodsName () {
      this.$toast.loading({
        duration: 0
      })
      this.$request.shop.cleanHistoryGoodsName()
        .then((response) => {
          this.selectGoodsCheckHotConfig()
        })
        .catch((error) => {
          console.log(error)
        })
    }
  }
}
</script>

<style>
  .mySearch .van-search .van-cell{
    padding: 3px 8px 3px 0;
  }
  .mySearch input {
    position: relative;
    font-size: 12px;
    font-family: lthj;
    top: 1px;
  }
  .mySearch input::-webkit-input-placeholder { /* WebKit browsers */
    color: #999999;
    position: relative;
    font-size: 12px;
    left: 2px;
  }
  .mySearch .van-search__content {
    background: #F6F6F6;
    margin-left: 13px;
  }
  .searchHistoryItem {
    height: 7.2vw;
    line-height: 7.2vw;
    background: #F1F1F1;
    border-radius: .8vw;
    font-size: 3.2vw;
    font-family: lthj;
    text-align: center;
    color: #868686;
    display: inline-block;
    padding: 0 3.47vw;
    margin-right: 2.67vw;
    margin-top: 2.67vw;
  }
  .searchHotItem {
    height: 12.27vw;
    display: flex;
    font-family: lthj;
    align-items: center;
    border-bottom: 1px solid #EAEAEA;
  }
  .searchHotIcon {
    font-family: din-bold;
    font-size: 3.47vw;
    color: #EF2018;
    width: 4.53vw;
    text-align: center;
    margin-right: 2.13vw;
  }
  /* .nVan-field__control /deep/ .van-field__control {
  background-color:#323233;
  padding: 8px 0;
  margin: 3.67vw 0;
  border-radius: 8px;
} */
</style>
